import axiosInstance from "../Utils/axiosInstance";
import { ChargeContactApi } from "../Constants/api";

export const getContactChargesApi = async (params) => {
  try {
    const searchParams = new URLSearchParams(params);
    let response = await axiosInstance.get(
      `${ChargeContactApi}?${searchParams.toString()}`
    );

    return response.data;
  } catch (error) {
    return error?.response?.data;
    // throw error; // Re-throw error for further handling if needed
  }
};
